import { useCustomerUserCount } from "@/api/services/main/customer-user";
import { IconBuilding } from "@/assets/icons";
import { Button } from "@/components/elements/Button";
import { InnerBox } from "@/components/elements/InnerBox";
import { Linkable } from "@/components/elements/Linkable";
import { useCurrentUserRole } from "@/features/auth/hooks/useCurrentUserRole";
import { AppRoutes } from "@/routes/config";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

export const UserCounting: FC = () => {
  const { canViewUsers } = useCurrentUserRole();
  const { count } = useCustomerUserCount();

  return (
    <InnerBox padding="24px">
      <Stack gap="16px">
        <Typography variant="head20Bold" color={text.primary}>
          ご利用ユーザー数
        </Typography>

        <Stack direction="row" gap={0.5} alignItems="baseline">
          <Typography variant="head28Bold" color={text.primary}>
            {count ?? "-"}
          </Typography>
          <Typography variant="head20Light" color={text.primary}>
            名
          </Typography>
        </Stack>
        {canViewUsers && (
          <Linkable href={AppRoutes.customerUsers}>
            <Button variant="secondary" size="md" fullWidth>
              <Stack direction="row" gap={1} alignItems="center">
                <IconBuilding />
                <Typography variant="sub16Semi">ユーザー管理へ</Typography>
              </Stack>
            </Button>
          </Linkable>
        )}
      </Stack>
    </InnerBox>
  );
};
